export default __webpack_public_path__ + "1e91f4cb4ed05d232eb7ea3e96b856eb.png";